import { TableHeadersType } from "../../../constant/tableHeadersConstants/tableHeadersType";
import { TableHeader, TableLoader } from "../../commons";
import ScrollToTop from "../../commons/ScrollToTop";
import InfiniteLoader from "../../commons/InfiniteLoader/InfiniteLoader";
import FixedAssetTableData from "./FixedAssetTableData";
import { FixedAssetUsersHistoryData } from "../../../redux/fixedAsset/fixedAssetRegisterTypes";
type AppProps = {
  offset: number;
  fetching: boolean;
  finacAssetListing: any;
  tableHeader: [] | TableHeadersType[];
  history: any;
  clientCode: number;
  persistData: any;
  handleConfirmationModal: () => void;
  handleDeleteData: (data: any) => void;
  handleHistoryFixedAssetModule: (data: any) => void;
  isEditFixedAssetPresent: boolean;
  isDeleteFixedAssetPresent: boolean;
  handleShowAssetUser:(data:any)=>void;
  fixedAssetUsersHistoryData:FixedAssetUsersHistoryData[] | [];
  assetHistoryFetching?:boolean;
  handleRemoveData:()=>void;

};
const FixedAssetTable = ({
  offset,
  fetching,
  tableHeader,
  finacAssetListing,
  history,
  clientCode,
  handleConfirmationModal,
  handleDeleteData,
  persistData,
  handleHistoryFixedAssetModule,
  isEditFixedAssetPresent,
  isDeleteFixedAssetPresent,
  handleShowAssetUser,
  fixedAssetUsersHistoryData,
  assetHistoryFetching,
  handleRemoveData
}: AppProps) => {
  return (
    <>
      {fetching && offset === 0 ? (
        <TableLoader Rows={7} ColumnPerRow={7} />
      ) : (
        <div style={{ width: "100%" }}>
          <div className="table-bordered disbursment table-responsive">
            <table className="table">
              <thead className=" sticky-table-header">
                <TableHeader tableHeader={tableHeader} />
              </thead>
              <tbody>
                <FixedAssetTableData
                  tableHeader={tableHeader}
                  history={history}
                  clientCode={clientCode}
                  handleConfirmationModal={handleConfirmationModal}
                  handleDeleteData={handleDeleteData}
                  finacAssetListing={finacAssetListing}
                  persistData={persistData}
                  handleHistoryFixedAssetModule={handleHistoryFixedAssetModule}
                  isEditFixedAssetPresent={isEditFixedAssetPresent}
                  isDeleteFixedAssetPresent={isDeleteFixedAssetPresent}
                  handleShowAssetUser={handleShowAssetUser}
                  fixedAssetUsersHistoryData={fixedAssetUsersHistoryData}
                  assetHistoryFetching={assetHistoryFetching}
                  handleRemoveData={handleRemoveData}
                />
                {fetching && offset > 0 && <div>{<InfiniteLoader />}</div>}
                <div style={{ display: fetching ? "none" : "inline" }}>
                  <ScrollToTop />
                </div>
              </tbody>
            </table>
          </div>
        </div>
      )}
    </>
  );
};

export default FixedAssetTable;
